import { Rate } from "../../rate/model/Rate";

export class LadderRate {
  baseCode: string;
  nonBaseCode: string;
  isInvert: boolean = false;
  pairName: string;
  invertPairName: string;
  pairIsEmpty: boolean = true;
  isLadderRate: boolean = true;
  selection: string;
  readonly dealtTracking = -0;

  aggregateId: string = null;

  currentOrderCount: number;

  rate: Rate = null;
}
